import { Directive, ElementRef, Input, OnInit, HostBinding } from '@angular/core';

import { AuthService } from '../services/auth.service';
import { SessionService } from '../services/session2.service';

@Directive({
  selector: '[auth-level]'
})
export class AuthLevelDirective implements OnInit {

	@Input('auth-level') al: string;
	@Input() level: string;

	@HostBinding('class.d-none')
	hidden = false;

	nativeDisplay: string;

  constructor(private el: ElementRef, private authService: AuthService, private sessionService: SessionService) {
    // sessionService.sessionRefresh$.subscribe(message => this.sessionRefresh());
    sessionService.getSession().subscribe((message: any) => this.sessionRefresh());
	}

  ngOnInit(): void {
		this.sessionRefresh();
	}

	private async sessionRefresh() {
  	this.nativeDisplay = this.el.nativeElement.style.display;
		const hasPermission = await this.authService.hasPermission(this.level)
  	if (hasPermission) {
			this.hidden = false;
  	}
  	else {
			this.hidden = true;
  	}
	}
}

@Directive({
  selector: '[auth-level-mask]'
})
export class AuthLevelMaskDirective implements OnInit {

	@Input('auth-level-mask') al: string;
	@Input() level: string;

	private nativeDisplay: string;

  constructor(private el: ElementRef, private authService: AuthService, private sessionService: SessionService) {
	}

  ngOnInit(): void {
  	this.nativeDisplay = this.el.nativeElement.style.display;
  	if (this.authService.currentRole.title == this.level) {
  		this.el.nativeElement.style.display = this.nativeDisplay;
  	}
  	else {
  		this.el.nativeElement.style.display = 'none';
  	}
	}

}



// WEBPACK FOOTER //
// ./client/app/directives/auth-level.directive.ts